"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDefined;
/**
 * Check if a value is defined
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isDefined(value) {
  return value !== undefined && value !== null;
}
//# sourceMappingURL=isDefined.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/isDefined.js